import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ListBaseComponent } from '../../../shared/components/base/list-base/list-base.component';
import { Constants } from '../../../shared/constants/constants';
import { Modals } from '../../../shared/constants/modals';
import { Permissions } from '../../../shared/constants/permissions';
import { Sections } from '../../../shared/constants/sections';
import { PaymentActionFilter } from '../../../shared/filters/payment-action.filter';
import { CompanyBase } from '../../../shared/models/company-base.model';
import { SectionService } from '../../../shared/services/section.service';
import { PaginationService } from 'ngx-pagination';
import { PaymentActionService } from '../../../shared/services/payment-action.service';
import { PaymentAction } from '../../../shared/models/payment-action.model';

@Component({
  selector: 'app-payment-actions-list',
  templateUrl: './payment-actions-list.component.html',
  styleUrls: ['./payment-actions-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class PaymentActionsListComponent extends ListBaseComponent implements OnInit {
  fieldCollection = [
    {
      name: 'CreatedAt',
      displayName: 'paymentActions.createdAtFieldTitle',
      canSort: true,
      displayClass: 'd-none d-sm-table-cell'
    },
    {name: 'Title', displayName: 'paymentActions.titleFieldTitle', canSort: true, displayClass: ''},
    {name: 'Company.Name', displayName: 'paymentActions.companyNameFieldTitle', canSort: true, displayClass: ''},
  ];

  paymentActionFilter: PaymentActionFilter;
  statusesUpdatedSuccessfullyMessage: string;

  get companySelectionListClass(): string {
    if (this.hasSelectCompanyPermission) {
      return 'd-none d-xl-block selection-list';
    }

    return '';
  }

  get hasSelectCompanyPermission(): boolean {
    return this.hasPermission(Permissions.PaymentActions_SelectCompany);
  }

  get hasEditPaymentActionPermission(): boolean {
    return this.hasPermission(Permissions.PaymentActions_Update);
  }

  get hasDeletePaymentActionPermission(): boolean {
    return this.hasPermission(Permissions.PaymentActions_Delete);
  }

  get hasViewPaymentActionPermission(): boolean {
    return this.hasPermission(Permissions.PaymentActions_View);
  }

  constructor(
    protected sectionService: SectionService,
    protected paymentActionService: PaymentActionService,
    protected translateService: TranslateService,
    protected modalService: NgbModal,
    protected toastrService: ToastrService) {
    super(sectionService, Sections.PaymentActions, modalService, Modals.PaymentActionComponent);
  }

  ngOnInit(): void {
    this.paymentActionFilter = new PaymentActionFilter();
    super.initializeView(Constants.PaymentActions_List_DefaultSortField, Constants.PaymentActions_List_DefaultSortDirectionAscending);
    this.translateService.get(['paymentActions.statusesUpdatedSuccessfullyMessage'])
      .subscribe(translations => {
        this.statusesUpdatedSuccessfullyMessage = translations['paymentActions.statusesUpdatedSuccessfullyMessage'];
      });
  }

  searchFilter(event: any): void {
    this.paymentActionFilter.RemittanceInformation = event.target.value.toLowerCase();
    this.getCollection();
  }

  handleCompanyChanged(company: CompanyBase): void {
    if (company) {
      this.paymentActionFilter.CompanyId = company.CompanyId;
    } else {
      this.paymentActionFilter.CompanyId = undefined;
    }

    this.getCollection(Constants.DefaultPageNumber);
  }

  handleBooleanToggleFilterChanged(): void {
    this.getCollection();
  }

  addPaymentAction(): void {
    const modalRef = this.openModal();
    modalRef.componentInstance.currentObject = null;
    modalRef.componentInstance.isEditMode = false;
  }

  editPaymentAction(paymentAction: any): void {
    if (this.hasEditPaymentActionPermission) {
      const modalRef = this.openEditModal(paymentAction);
      modalRef.componentInstance.isEditMode = true;
    }
  }

  viewPaymentAction(paymentAction: any): void {
    const modalRef = this.openEditModal(paymentAction);
    modalRef.componentInstance.isViewMode = true;
  }

  deletePaymentAction(paymentAction: PaymentAction): void {
    this.translateService.get(['paymentActions.deletedPaymentActionTitle'])
      .subscribe(translations => {
        this.paymentActionService.deletePaymentAction(
          paymentAction.Id,
          () => this.getCollection(this.pageConfiguration.PageNumber),
          translations['paymentActions.deletedPaymentActionTitle']
        );
      });
  }

  getCollection(pageNumber: number = 1): void {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }
    this.paymentActionService.getCollectionPaginated<PaymentAction>(
      '/payment-action/all',
      this.pageConfiguration,
      this.paymentActionFilter,
      (collection: PaymentAction[]) => {
        this.collection = collection;
      }
    );
  }

  openCopyModal(paymentAction: PaymentAction): void {
    if (!paymentAction.CompanySlug || paymentAction.CompanySlug.length === 0) {
      this.translateService.get([
          'paymentActions.copyFailedMessageTitle',
          'company.missingCompanySlugMessage'
        ],
        {CompanyName: paymentAction.CompanyName}
      ).subscribe((translations: string[]) => {
        this.toastrService.error(
          translations['company.missingCompanySlugMessage'],
          translations['paymentActions.copyFailedMessageTitle']
        );
      });
      return;
    }
    this.openCustomModal('PaymentActionsUrlComponent', paymentAction, 'modal-backdrop-blur');
  }
}
